import React from 'react';

const bookItemsModel = ({ show, handleClose, title, content }) => {
    // console.log(typeof content.book_items);
    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const bookDate = new Date(content.book_date);

    const bookItems = content.book_items && JSON.parse(content.book_items);
    return (
        <>
            {show && (
                <div className="modal" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header border-0 pt-0">
                                <h5 className="modal-title fw-bold">{title}</h5>
                                <button type="button" className="close btn " onClick={handleClose}>
                                    <span aria-hidden="true" className='fs-1'>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body fs-custom">
                                <p className='mb-2 text-dark'>Customer: <span className='fw-bold text-capitalize'>{content.firstName}  {content.lastName}</span></p>
                                <p className='text-dark'>Appointment Time: <span className='fw-bold'>{weekdays[bookDate.getDay()]} {months[bookDate.getMonth()]} {bookDate.getDate()} {bookDate.getFullYear()} {content.book_time}</span></p>
                                <h5 className='mt-3 mb-2'>Booked Services</h5>
                                <table className='table table-bordered '>
                                    <thead>
                                        <tr className="table-active">
                                            <th scope="col">Name</th>
                                            <th scope="col">Duration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bookItems.map((item) => {
                                            return (<tr><td>{item.name}</td><td>{`${Math.floor(item.duration / 60)} H : ${item.duration % 60} Min `}</td></tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {show && <div className="modal-backdrop fade show"></div>}
        </>
    )
}


export default bookItemsModel
